
const filterTypes = {
    Platform: 'Platform',
    Date: 'Date',
    Apps: 'Apps',
    AppsPlacements: 'App \\ Placement',
    Placement: 'Placement',
    PlacementCountry: 'Placement \\ Country',
    Country: 'Country',
    CountryPlacement: 'Country \\ Placement',
    Advertiser: 'Advertiser'
}

export default filterTypes;



// WEBPACK FOOTER //
// ./src/components/Revenue/filterTypes.js